import React from "react";

function PrivacyPoliciesPage() {
  return (
    <article className="max-w-[60vw] text-center absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2">
      <h1 className="font-bold text-4xl mb-4">AVISO LEGAL</h1>
      <p className="text-xl text-justify">
        Las presentes condiciones tienen por finalidad regular el uso del Portal
        Web Ventanilla Única de Servicios Ambientales{" "}
        <span className="font-bold">(VUSA)</span> que el Ministerio de Medio
        Ambiente y Recursos Naturales pone a disposición del público.
      </p>
      <br />
      <h2 className="font-bold text-2xl mb-4">Usuarios</h2>
      <p className="text-xl text-justify">
        El acceso y uso de VUSA atribuye la condición de USUARIO, que acepta,
        desde dicho acceso y uso las condiciones generales aquí reflejadas.{" "}
      </p>
      <br />
      <h2 className="font-bold text-2xl mb-4">Uso del Portal </h2>
      <p className="text-xl text-justify">
        VUSA permite acceso del USUARIO a los servicios que ofrece el Ministerio
        de Medio Ambiente y Recursos Naturales. El USUARIO asume total
        responsabilidad del uso del portal Web y de la veracidad de la
        información suministrada en los formularios de solicitud de servicios de
        portal y de acceso. La responsabilidad del USUARIO se extiende al uso de
        la clave de acceso e implica su consentimiento expreso de que la
        información suministrada quede incorporada a la base de datos propiedad
        del Ministerio de Medio Ambiente y Recursos Naturales.
      </p>
      <br />
      <h2 className="font-bold text-2xl mb-4">Protección de Datos</h2>
      <p className="text-xl text-justify">
        La base de datos de este portal web es administrada bajo principios de
        seguridad, protección y confidencialidad de datos personales de
        conformidad con las disposiciones de la Ley de Protección de Datos
        Personales <span className="font-bold">No. 172-13.</span> El usuario
        reconoce y acepta que la información suministrada será utilizada para
        mejorar los servicios del portal web y que en ningún caso será divulgada
        o relevada a terceros.
      </p>
      <br />
      <h2 className="font-bold text-2xl mb-4">Menores de Edad</h2>
      <p className="text-xl text-justify">
        Ventanilla Única de Servicios Ambientales{" "}
        <span className="font-bold">(VUSA)</span> dirige sus servicios a mayores
        de 18 años conforme lo dispuesto por el{" "}
        <span className="font-bold">artículo 4888</span> del Código Civil de la
        República Dominicana. Los menores de no están autorizados a utilizar los
        servicios de VUSA y suministrar sus datos personales, sino a través de
        sus padres o tutores legales. En consecuencia, el Ministerio de Medio
        Ambiente y Recursos Naturales no se hace responsable de posibles
        consecuencias ni daños a terceros que pudieran derivarse del
        incumplimiento del aviso que en esta cláusula se establece.
      </p>
    </article>
  );
}

export default PrivacyPoliciesPage;
